import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  session: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/session/index.js